import { useAdminActionFeedContext } from '../../context/AdminActionFeedContext';

interface NotificationBellProps {
  // Kept for backward-compat with existing call sites; the bell now reads
  // state from AdminActionFeedContext shared with the rest of the layout.
  token: string | null;
  onClick: () => void;
}

function NotificationBell({ onClick }: NotificationBellProps) {
  const { unreadCount, capped } = useAdminActionFeedContext();
  const tooltipText = unreadCount === 0
    ? 'Notifications'
    : capped
    ? '100+ new updates'
    : `${unreadCount} new update${unreadCount === 1 ? '' : 's'}`;

  return (
    <button
      className="notif-bell"
      onClick={onClick}
      title={tooltipText}
      aria-label={tooltipText}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      {unreadCount > 0 && <span className="notif-bell__dot" aria-hidden="true" />}
    </button>
  );
}

export default NotificationBell;
